import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=1377cc8f&scoped=true&"
import script from "./OrderItem.vue?vue&type=script&lang=js&"
export * from "./OrderItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=1377cc8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1377cc8f",
  null
  
)

export default component.exports